import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { ToastrService } from 'ngx-toastr';
import { ConfirmDialogComponent } from 'src/app/shared/components/confirm-dialog/confirm-dialog.component';
import { TasksService } from 'src/app/shared/services/task-service/tasks.service';
import { UserDetailsService } from 'src/app/shared/services/user-details.service';
import { UtilsService } from 'src/app/shared/services/utils-service/utils.service';

@Component({
  selector: 'app-workflow-template-list',
  templateUrl: './workflow-template-list.component.html',
  styleUrls: ['./workflow-template-list.component.scss']
})
export class WorkflowTemplateListComponent implements OnInit {

  @Input() taskId: any;
  @Input() workflow_template_id: any;
  @Input() isDraftTask = false;
  displayedColumnDayGap: string[] = ['subtask_name','createdAt','day_gap','due_date','assignee', 'action'];
  displayedColumnStatus: string[] = ['subtask_name','createdAt','due_date','assignee', 'action'];
  displayedColumns: string[] = [];
  onlineArr: any = [];
  imported_workflow_id:any;
  userRolePermission:any;
  ELEMENT_DATA: any = [];
  dataSource = new MatTableDataSource(this.ELEMENT_DATA);
  @Output() isRefreshTaskPage = new EventEmitter<any>();

  constructor(public taskService:TasksService, public utils:UtilsService,public dialog: MatDialog,private toastrService: ToastrService,public userDetailService:UserDetailsService,
    public _cd: ChangeDetectorRef) { }

  async ngOnInit() {
    this.userRolePermission = await this.userDetailService.getUserRolePermissions();
    await this.getWorkflowTemplateTaskList();
  }

  async getWorkflowTemplateTaskList(){
    (await this.taskService.getWorkflowTemplateTaskList(this.workflow_template_id,this.taskId)).subscribe((res:any) => {
      if(res?.result?.length){
        this.ELEMENT_DATA = [];
        this.displayedColumns = (res?.result[0]?.workflow_data?.sub_type == 'on_status') ? [...this.displayedColumnStatus] : [...this.displayedColumnDayGap];
        this.imported_workflow_id = res?.result[0]?._id;
        const arr:any[] = res.result[0]?.workflow_data?.tasks?.map((ele: any) => ({
          subtask_name: ele?.subtask_name || '',
          day_gap: ele?.day_gap || 0,
          due_date: ele?.due_date || 0,
          start_date: ele?.start_date || 0,
          assignees: ele?.assignees?.length ? ele.assignees : [],
          groups: ele?.groups?.length ? ele.groups : [],
          is_created: ele?.is_created || false,
          priority: ele?.priority,
          _id: ele?._id,
          createdAt: ele?.createdAt ? ele?.createdAt : null
        })) || [];
        this.ELEMENT_DATA = Object.assign([],arr);
        this.dataSource = new MatTableDataSource(this.ELEMENT_DATA);
      }
      
    })
  }


  async createTemplateTask(event:any,id:any,template:any){
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: {
        message: `Are sure want to create <strong>${template?.subtask_name}</strong> template task?`,
        buttonText: {
          ok: "Yes",
          cancel: "No",
        },
      },
    });
    dialogRef.afterClosed().subscribe(async (confirmed: boolean) => {
      if (confirmed) {
        if(event?.checked){
          (await this.taskService.manualTaskCreation(this.imported_workflow_id,this.taskId,id)).subscribe(async (res:any) => {
            if(res?.taskId || res?.message){
              this.toastrService.success('Created task successfully');
              await this.getWorkflowTemplateTaskList();
              this.isRefreshTaskPage.emit(true)
            }
          })
        }
      }else{
        setTimeout(() => {
          const arr:any[] = this.ELEMENT_DATA.map((template: any) => {
            if (template?._id === id) {
              return { ...template, is_created: false };
            }
            return template;
          });
          this.dataSource = new MatTableDataSource(arr);
          this._cd.detectChanges();
        }, 100);
      }
    });
  }
}
